var map = {
	"./fun-time/config": "3937",
	"./fun-time/games/page000_game0/config": "1bfc",
	"./fun-time/games/page000_game1/config": "60a7",
	"./fun-time/games/page000_game2/config": "246d",
	"./fun-time/games/page001_game0/config": "b64d",
	"./fun-time/games/page001_game1/config": "d4f7",
	"./fun-time/games/page002_game0/config": "6273",
	"./fun-time/games/page002_game1/config": "8d25",
	"./fun-time/games/page003_game1/config": "583e",
	"./fun-time/games/page003_game2/config": "bb8e",
	"./fun-time/games/page003_game3/config": "46a3",
	"./fun-time/games/page004_game0/config": "c073",
	"./fun-time/games/page004_game1/config": "5d46",
	"./fun-time/games/page005_game1/config": "7c90",
	"./fun-time/games/page005_game2/config": "6f79",
	"./fun-time/games/page005_game3/config": "c55f",
	"./fun-time/games/page005_game4/config": "3bc3",
	"./fun-time/games/page005_game5/config": "3872",
	"./fun-time/games/page006_game0/config": "aacc",
	"./fun-time/games/page006_game1/config": "f85d",
	"./fun-time/games/page007_game0/config": "d701",
	"./fun-time/games/page008_game1/config": "82aa",
	"./fun-time/games/page008_game2/config": "8ea1",
	"./fun-time/games/page008_game3/config": "748a",
	"./fun-time/games/page008_game4/config": "1933",
	"./fun-time/games/page009_game0/config": "787f",
	"./fun-time/games/page010_game0/config": "c192"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf6f";